// src/widgets/staff/flagPaths.js

export const EIGHTH_FLAG_PATH =
  "M0 0h-16v250h16c98 58 227 148 227 259c0 57 -16 112 -41 163" +
  "c-3 16 10 27 23 27c7 0 15 -3 20 -11c25 -56 40 -117 40 -179" +
  "c0 -204 -269 -305 -269 -509z";

export const SIXTEENTH_FLAG_PATH = "M0 0c0 -178 203 -292 203 -470c0 -33 -9 -65 -23 -95c18 -37 29 -75 29 -117c0 -63 -16 -125 -42 -183c-5 -8 -12 -12 -19 -12c-13 0 -26 11 -23 27c26 52 42 110 42 168c0 97 -95 191 -167 257v-75h-16v500h16zM153 -517c5 15 7 31 7 47c0 96 -91 190 -160 257 c0 -118 91 -206 153 -304z";

export const THIRTY_SECOND_FLAG_PATH =
  "M0 -212v-5c0 -110 85 -194 144 -285c3 11 5 23 5 35" +
  "c0 93 -85 187 -149 255zM0 0c0 -175 191 -292 191 -467" +
  "c0 -29 -8 -57 -19 -84c17 -35 29 -71 29 -111" +
  "c0 -36 -8 -72 -23 -105c18 -35 29 -72 29 -113" +
  "c0 -60 -15 -119 -41 -173c-5 -8 -13 -11 -20 -11" +
  "c-13 0 -26 11 -23 27c26 49 42 102 42 157" +
  "c0 91 -94 175 -165 233v-103h-16v750h16z";
